import requireAll from '../requireAll';

import './_module';

requireAll(require.context('./changelog', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./help-desk', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./landing', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./my-supports', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./not-found', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./school-metrics', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./support-attendance-form', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./support-overview', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./supports', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./manage-users', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
requireAll(require.context('./supports', true, /(?!\.spec)(\S{5}|^\S{1,4})(\.js$|\.ts$)/));
